import {
  ACCOUNT_HOST,
  IS_SSO,
  SSO_CONTINUE_ENDPOINT,
  SSO_CLIENT_ID,
  GENERIC_SUCCESS_JSON_URL,
} from '../constants';
import { getAxiosInstance } from './util/axios-util';
import { isEmptyString } from '../util/object';

/**
 * Loads the SSO ticket from the accounts service
 * @returns {AxiosPromise}
 */
export const getSSOTicket = () => {
  if (!IS_SSO) {
    throw new Error('Cannot get SSO ticket in non-SSO environment');
  }

  const axios = getAxiosInstance();
  return axios({
    data: `client_id=${SSO_CLIENT_ID}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    },
    method: 'post',
    url: `${ACCOUNT_HOST}/accounts/sso`,
    withCredentials: true,
  });
};

/**
 * Sets a ticket on the SSO Continue endpoint pointed at a placeholder json file.
 * @param {String} ticket - SSO ticket to set
 * @returns {AxiosPromise}
 */
export const setSSOTicket = (ticket) => {
  if (!IS_SSO) {
    throw new Error('Cannot set SSO ticket in non-SSO environment');
  }

  if (isEmptyString(ticket)) {
    throw new Error('Cannot set an empty ticket.');
  }

  const axios = getAxiosInstance();
  return axios({
    method: 'get',
    params: {
      srcPath: GENERIC_SUCCESS_JSON_URL,
      ticket,
    },
    url: SSO_CONTINUE_ENDPOINT,
    withCredentials: true,
  });
};

export const logout = () => {
  const axios = getAxiosInstance();
  return axios({
    method: 'get',
    url: '/logout',
  });
};

export const logoutSSO = () => {
  if (!IS_SSO) {
    return Promise.resolve('No need to log out of SSO in non-SSO environment.');
  }

  const axios = getAxiosInstance();
  return axios({
    data: `client_id=${SSO_CLIENT_ID}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    },
    method: 'post',
    url: `${ACCOUNT_HOST}/accounts/client_logout`,
    withCredentials: true,
  });
};
